import { DropdownItemReg } from '../types/ViewModel/DropdownItemReg';
import { DropdownGroup } from '../types/ViewModel/DropdownGroup';
import { DropdownItemRegBM } from '../types/BusinessModel/DropdownItemRegBM';
import { SelectOption } from '../types/ViewModel/SelectOption';
import eventtypecommon from '../utils/event/eventtypecommon';

export default () => {
    const { generateUuid } = eventtypecommon();

    const newDropdownItemRegArray = (dropdownItemRegList: DropdownItemRegBM[]): DropdownItemReg[] => {
        const drItemRegList: DropdownItemReg[] = [];
        dropdownItemRegList.map((reg) => drItemRegList.push(newDropdownItemReg(reg)));
        return drItemRegList;
    };

    const newDropdownItemReg = (dropdownItemReg: DropdownItemRegBM): DropdownItemReg => {
        let dropdownItemRegId: string;
        if (dropdownItemReg.dropdownItemRegId) {
            dropdownItemRegId = dropdownItemReg.dropdownItemRegId;
        } else {
            dropdownItemRegId = generateUuid();
        }
        return new DropdownItemReg(dropdownItemRegId, dropdownItemReg.dropdownItemId, dropdownItemReg.dropdownItemValue);
    };

    const createDropdownItemFromCode = (
        dropdownItemRegId: string,
        dropdownItemId: number,
        dropdownItemValue: string,
        eventTypeGroupSequenceIdentity: string
    ): DropdownItemReg => {
        const ddirItem = new DropdownItemReg(dropdownItemRegId, dropdownItemId, dropdownItemValue);
        ddirItem.eventTypeGroupSequenceIdentity = eventTypeGroupSequenceIdentity;
        return ddirItem;
    };

    const createDropdownItemRegArray = (dropdownItemRegArray: DropdownItemReg[]): DropdownItemReg[] => {
        if (dropdownItemRegArray && dropdownItemRegArray.length > 0) {
            const drItemRegList: DropdownItemReg[] = [];
            dropdownItemRegArray.map((reg) => drItemRegList.push(createDropdownItemReg(reg)));
            return drItemRegList;
        }
        return [];
    };

    const createDropdownItemReg = (dropdownItemReg: DropdownItemReg): DropdownItemReg => {
        const ddirItem = new DropdownItemReg(dropdownItemReg.dropdownItemRegId, dropdownItemReg.dropdownItemId, dropdownItemReg.dropdownItemValue);
        ddirItem.eventTypeGroupSequenceIdentity = dropdownItemReg.eventTypeGroupSequenceIdentity;
        return ddirItem;
    };

    const addDropdownItemRegFromSelection = (selection: SelectOption, dropdownItemRegArray: DropdownItemReg[]): DropdownItemReg[] => {
        const dropdownItemReg = dropdownItemRegArray.find((ddi) => ddi.dropdownItemId === +selection.value);
        if (!dropdownItemReg) {
            const newItemReg = new DropdownItemReg(generateUuid(), +selection.value, selection.label);
            dropdownItemRegArray.push(newItemReg);
        }
        return dropdownItemRegArray;
    };

    const removeDropdownItemRegFromSelection = (selection: SelectOption, dropdownItemRegArray: DropdownItemReg[]): DropdownItemReg[] => {
        const dropdownItemIndex = dropdownItemRegArray.findIndex((ddi) => ddi.dropdownItemId === +selection.value);
        if (dropdownItemIndex > -1) {
            dropdownItemRegArray.splice(dropdownItemIndex, 1);
        }
        return dropdownItemRegArray;
    };

    const setDropdownItemRegFromSelection = (selectionArray: SelectOption[]): DropdownItemReg[] => {
        return selectionArray.map((eti: SelectOption) => {
            return new DropdownItemReg(generateUuid(), +eti.value, eti.label);
        });
    };

    const createDropdownItemRegfromSelection = (selectedIds: number[], dropdownGroup: DropdownGroup): DropdownItemReg[] => {
        return dropdownGroup.dropdownItemArray
            .filter((di) => {
                return selectedIds.some((id) => {
                    return id === di.id;
                });
            })
            .map((eti) => {
                return new DropdownItemReg(generateUuid(), eti.dropdownItemId, eti.name);
            });
    };
    const createDropdownItemRegListBM = (dropdownItemRegList: DropdownItemReg[]): any[] => {
        return dropdownItemRegList.map((item) => {
            return {
                dropdownItemRegId: item.dropdownItemRegId,
                dropdownItemId: item.dropdownItemId,
                dropdownItemValue: item.dropdownItemValue,
            };
        });
    };

    return {
        newDropdownItemRegArray,
        newDropdownItemReg,
        createDropdownItemFromCode,
        createDropdownItemRegArray,
        createDropdownItemReg,
        addDropdownItemRegFromSelection,
        removeDropdownItemRegFromSelection,
        setDropdownItemRegFromSelection,
        createDropdownItemRegfromSelection,
        createDropdownItemRegListBM,
    };
};
